var _circle, _line, _line2, _line3, _line4, _line5, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuEndpoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 10.5,
    r: 8,
    stroke: "#217EE2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 2.5,
    y2: 0.5,
    transform: "matrix(0 1 1 0 10 4)",
    stroke: "#217EE2",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 2.5,
    y2: 0.5,
    transform: "matrix(1 0 0 -1 3 10)",
    stroke: "#217EE2",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 2.5,
    y2: 0.5,
    transform: "matrix(1 0 0 -1 13 10)",
    stroke: "#217EE2",
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 5.30228,
    y1: 5.90159,
    x2: 6.29773,
    y2: 7.90385,
    stroke: "#217EE2",
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 2.5,
    y2: 0.5,
    transform: "matrix(-0.798635 0.601815 0.601815 0.798635 14.396 6)",
    stroke: "#217EE2",
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.13558 12.2307L11.0776 10.7372L9.88249 12.7798C9.73995 13.0176 9.49777 13.2092 9.2567 13.302C9.00948 13.3972 8.86249 13.3596 8.7942 13.31C8.70633 13.2461 8.64123 13.1262 8.68005 12.9193C8.71928 12.7103 8.86506 12.4528 9.13558 12.2307Z",
    stroke: "#217EE2",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuEndpoint);
export default __webpack_public_path__ + "static/media/menu-endpoint.a2005d7a901ec5289302c42e97caa795.svg";
export { ForwardRef as ReactComponent };